import React, {useEffect, useState} from 'react';
import {Container, Row, Col, Card, Modal} from 'react-bootstrap';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode } from 'swiper/modules';

import VideoModal from './VideoModal';
import {getProducer} from "../api/ProfileAPIs";
import {showWarning} from "../../../utils/toastHelper";
import Loading from "../../../layouts/Loading";
import {useNavigate, useParams} from "react-router-dom";
import Header from "../../../layouts/Header";
import {TiChevronLeftOutline} from "react-icons/ti"; // مودال ویدئو


// فرض می‌شود این تابع به صورت گلوبال در دسترس است
// declare function showWarning(message: string): void;

function ProducerDetail() {
    const {id} = useParams();
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [producer, setProducer] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducers = async () => {

            const params = {

                perPage : 6
            };


            try {
                const data = await getProducer(id,params);
                setProducer(data?.data || []);
            } catch (error) {
                console.error("Failed to fetch producers:", error);
                setProducer([]);
            } finally {
                setLoading(false);
            }
        };
        fetchProducers();

    }, []);

    // تابع برای مدیریت کلیک روی دکمه کاتالوگ
    const handleCatalogClick = () => {
        if (producer.catalog?.path) {
            window.open(producer.catalog.path, '_blank');
        } else {

            showWarning('فایل کاتالوگ برای این تولیدکننده وجود ندارد.');
        }
    };

    // تابع برای مدیریت کلیک روی دکمه ویدئو
    const handleVideoClick = () => {
        if (producer.video) {
            setShowVideoModal(true);
        } else {

            showWarning('ویدئو معرفی برای این تولیدکننده وجود ندارد.');
        }
    };

    const handleShowModal = (videoUrl) => {
        setSelectedVideo(videoUrl);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedVideo(null); // ویدیو را پس از بستن پاک کن
    };

    if (loading) return <Loading />;

    return (
        <Container className="producer-detail-page py-4 mt-5">
            <Header hasBack={true} transparent={false} title='اطلاعات تولید کننده'/>
            {/* 1. Header Section */}
            <Card className="section-card p-3 mb-4">
                <Row className="align-items-center producer-header">
                    <Col xs="auto">
                        <img src={producer.image} alt={producer.name} className="producer-image rounded-circle"/>
                    </Col>
                    <Col>
                        <h4 className="fw-bold mb-1">{producer.name}</h4>
                        <p className="text-muted mb-3 text-small-3 text-justify">{producer.brief}</p>
                        <div className="d-flex gap-2">
                            <button className="btn action-btn btn-video" onClick={handleVideoClick}>
                                <i className="bi bi-play-circle me-1"></i> ویدیو معرفی
                            </button>
                            <button className="btn action-btn btn-catalog" onClick={handleCatalogClick}>
                                <i className="bi bi-file-earmark-arrow-down me-1"></i> کاتالوگ معرفی
                            </button>
                        </div>
                    </Col>
                </Row>
            </Card>

            {/* 2. Stories (Announcements) Section */}


            {producer.stories && producer.stories.length > 0 && (
                <Card className="section-card p-3 mb-4">
                    <h5 className="fw-bold mb-3">اطلاعیه‌ها</h5>
                    <Swiper
                        modules={[FreeMode]}
                        spaceBetween={20}
                        slidesPerView="auto"
                        freeMode={true}
                        className="stories-slider"
                    >


                        <div className="stories-container container" dir="rtl">
                            <div className="d-flex flex-row flex-nowrap overflow-auto py-2">
                                {producer.stories.map((story) => (

                                    <div key={story.id} className="story-card-wrapper"
                                         onClick={() => handleShowModal(story.video)}>
                                        <div className="story-card">
                                            {story.cover ? (
                                                <img src={story.cover} className="story-background" alt={story.title}/>
                                            ) : (

                                                <video src={story.video + '#t=0.1'} className="story-background"
                                                       preload="metadata"
                                                       muted/>
                                            )}
                                            <div className="story-overlay">
                                                <img src={story.vendor?.image} className="vendor-avatar"
                                                     alt={story.vendor?.title}/>
                                                <span className="vendor-title">{story.title}</span>
                                            </div>
                                        </div>
                                    </div>

                                ))}
                            </div>
                        </div>

                    </Swiper>
                </Card>
            )}

            {/* 3. About Us Section */}
            {producer.description && (
                <Card className="section-card p-3 mb-4 about-section">
                    <h5 className="fw-bold mb-3">درباره تولید کننده</h5>
                    <div className='text-small-2 text-justify fw-normal' dangerouslySetInnerHTML={{__html: producer.description}}/>
                </Card>
            )}

            {/* 4. Products Section */}
            {producer.products && producer.products.length > 0 && (
                <>
                    <div className="row mx-1">
                        <div className="col-8 home-separator-text ">

                            محصولات
                        </div>
                        <div className="col-4 text-start text-small-3 text-secondary-color mt-1"

                             onClick={() => navigate('/producer-products/'+id)}
                        >
                            مشاهده همه
                            <TiChevronLeftOutline className='mx-1'/>
                        </div>
                    </div>
                    <Swiper
                        modules={[Navigation]}
                        spaceBetween={5}
                        slidesPerView={2.5} // نمایش ۲ آیتم و بخشی از آیتم سوم
                        navigation
                        className="products-slider"
                    >
                        {producer.products.map((product) => (
                            <SwiperSlide key={product.id}>
                                <div className="product-card"
                                     onClick={
                                         () => {
                                             navigate(`/product/${product.id}`)

                                         }
                                     }
                                >
                                    <img src={product.image} alt={product.name} className="product-image"/>
                                    <div className="p-3">
                                        <p className="product-name text-justify mb-2 text-small-2">
                                            {product.name.substring(0, 30)}

                                        </p>
                                        <p className="product-price">
                                        {product.vendor_price.price > 0
                                                ? `${product.vendor_price.price.toLocaleString('fa-IR')} تومان`
                                                : 'قیمت نامشخص'}
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </>
            )}

            {/* Video Modal */}
            <VideoModal
                show={showVideoModal}
                onHide={() => setShowVideoModal(false)}
                videoHtml={producer.video}
            />

            <Modal
                show={showModal}
                onHide={handleCloseModal}
                fullscreen={true} // این پراپرتی مودال را تمام صفحه می‌کند
                className="video-modal-fullscreen" // کلاس سفارشی برای استایل‌دهی
            >
                <Modal.Body>
                    <button onClick={handleCloseModal} className="btn-close-modal" aria-label="Close"></button>
                    {selectedVideo && (
                        <video
                            className="fullscreen-video-player"
                            controls
                            autoPlay
                            src={selectedVideo}
                            onEnded={handleCloseModal}
                        >
                            مرورگر شما از تگ ویدیو پشتیبانی نمی‌کند.
                        </video>
                    )}
                </Modal.Body>
            </Modal>
        </Container>
    );
}

export default ProducerDetail;
